import React from 'react';
import { Alert, Paper, Box } from '@mui/material';
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, GridToolbarExport, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import LoadingOverlay from '../../loadingOverlay/LoadingOverlay';
import maybeFormatDate from './../surveys/charts/maybeFormatDate';

const CustomToolbar = exportFileName => {
    return (
        <GridToolbarContainer sx={{ p:1 }}>
            <GridToolbarQuickFilter
                variant="outlined"
                size="small"
            />
            <Box sx={{ flex: 1 }} />
            <GridToolbarFilterButton />
            <GridToolbarColumnsButton />
            <GridToolbarDensitySelector
                slotProps={{
                    tooltip: {
                        title: 'Change density'
                    }
                }}
            />
            <GridToolbarExport
                csvOptions={{
                    fileName: exportFileName
                }}
            />
        </GridToolbarContainer>
    );
};

const SurveyResultsTable = ({ questions, answers, exportFileName }) => {
    const baseTheme = useTheme();

    const theme = createTheme({
        ...baseTheme,
        components: {
            MuiButton: {
                defaultProps: {
                    variant: 'text'
                }
            }
        }
    });

    if (!questions) {
        return (
            <Alert severity="error">
                Survey Data Not Found
            </Alert>
        );
    }

    if (!answers) {
        return (
            <LoadingOverlay />
        );
    }

    // This doesn't handle (matrix dynamic/dropdown) sub qs... they're JSON anyway, maybe acceptable for dates to be in raw format
    const tableData = answers.map(row => {
        return Object.fromEntries(
            Object.entries(row).map(([key, value]) => {
                const inputType = questions.find(q => q.field === key)?.inputType;

                let newValue = value;

                if (inputType === 'datetime-local' || inputType === 'date') {
                    const { str } = maybeFormatDate(value, inputType);

                    newValue = str;
                }

                return [key, newValue];
            })
        );
    });

    return (
        <ThemeProvider theme={theme}>
            <Paper>
                <DataGrid
                    rows={tableData}
                    columns={questions}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 10
                            }
                        }
                    }}
                    pageSizeOptions={[10, 20, 50, 100]}
                    disableRowSelectionOnClick
                    slots={{
                        toolbar: () => CustomToolbar(exportFileName)
                    }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true
                        }
                    }}
                />
            </Paper>
        </ThemeProvider>
    );
};

export default SurveyResultsTable;